import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";

import './App.css';
import TruthDare from "./pages/TruthDare";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/truthdare" element={<TruthDare />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
